import { Component, OnInit } from "@angular/core"
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from "@angular/forms"

@Component({
    selector: "app-data-privacy-acknowledgment",
    templateUrl: "./data-privacy-acknowledgment.component.html",
    styleUrls: ["./data-privacy-acknowledgment.component.scss"],
})
export class DataPrivacyAcknowledgmentComponent implements OnInit {
    privacyCheck: FormControl

    ngOnInit(): void {
        this.privacyCheck = new FormControl(false, this.checkBoxValidator())
    }

    get privacyCheckControl(): FormControl {
        return this.privacyCheck
    }

    checkBoxValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return !control.value ? { required: true } : null
        }
    }
}
